export function createOptionsFromRecord<
  T extends Record<string, { value: number; description: string }>
>(record: T) {
  return Object.values(record).map((item) => ({
    value: item.value,
    label: item.description,
  }));
}